import zipObject from 'lodash/zipObject';

/*
 * App actions
 */

const ACTIONS = [
  'CREATE_QUOTE',
  'CREATE_QUOTE_SUCCESS',
  'CREATE_QUOTE_FAILURE',

  'GET_PLANS',
  'GET_PLANS_SUCCESS',
  'GET_PLANS_FAILURE',

  'UPDATE_QUOTE',
  'UPDATE_QUOTE_SUCCESS',
  'UPDATE_QUOTE_FAILURE',

  'CHECKOUT_QUOTE',
  'CHECKOUT_QUOTE_SUCCESS',
  'CHECKOUT_QUOTE_FAILURE',

  'ADD_PAYMENT_METHOD_TO_QUOTE',
  'ADD_PAYMENT_METHOD_TO_QUOTE_SUCCESS',
  'ADD_PAYMENT_METHOD_TO_QUOTE_FAILURE',

  'GET_QUOTE_VARS',
  'GET_QUOTE_VARS_SUCCESS',
  'GET_QUOTE_VARS_FAILURE',

  'UPDATE_QUOTE_DETAILS',
  'UPDATE_VARIABLE_SELECTIONS',

  'FINALIZE_QUOTE',
  'FINALIZE_QUOTE_SUCCESS',
  'FINALIZE_QUOTE_FAILURE',

  'GET_POLICIES',
  'GET_POLICIES_SUCCESS',
  'GET_POLICIES_FAILURE',

  'GET_POLICY',
  'GET_POLICY_SUCCESS',
  'GET_POLICY_FAILURE',

  'UPDATE_POLICY',
  'UPDATE_POLICY_SUCCESS',
  'UPDATE_POLICY_FAILURE',

  'GET_POLICY_VARS',
  'GET_POLICY_VARS_SUCCESS',
  'GET_POLICY_VARS_FAILURE',

  'GET_POLICY_CHECKOUT',
  'GET_POLICY_CHECKOUT_SUCCESS',
  'GET_POLICY_CHECKOUT_FAILURE',

  'UPDATE_EDITING_POLICY',
  'CLEAR_EDITING_POLICY',

  'UPDATE_STAGED_AUTO_POLICY',
  'CLEAR_STAGED_AUTO_POLICY',

  'CANCEL_POLICY',
  'CANCEL_POLICY_SUCCESS',
  'CANCEL_POLICY_FAILURE',

  'GET_USER',
  'GET_USER_SUCCESS',
  'GET_USER_FAILURE',

  'UPDATE_USER',
  'UPDATE_USER_SUCCESS',
  'UPDATE_USER_FAILURE',

  'UPDATE_USER_PASSWORD',
  'UPDATE_USER_PASSWORD_SUCCESS',
  'UPDATE_USER_PASSWORD_FAILURE',

  'CREATE_RENTTRACK_USER',
  'CREATE_RENTTRACK_USER_SUCCESS',
  'CREATE_RENTTRACK_USER_FAILURE',

  'SEND_PRIOR_COVERAGE_TERMINATION',
  'SEND_PRIOR_COVERAGE_TERMINATION_SUCCESS',
  'SEND_PRIOR_COVERAGE_TERMINATION_FAILURE',

  'EXCHANGE_ACTIVATION_TOKEN',
  'EXCHANGE_ACTIVATION_TOKEN_SUCCESS',
  'EXCHANGE_ACTIVATION_TOKEN_FAILURE',

  'DISMISS_REMINDER',
  'RESET_REMINDERS',

  'SAVE_OKTA_ID_TOKEN',
  'SAVE_OKTA_ACCESS_TOKEN',

  'REFRESH_OKTA_TOKENS',
  'REFRESH_OKTA_TOKENS_SUCCESS',
  'REFRESH_OKTA_TOKENS_FAILURE',

  'GET_FEATURE_FLAGS',
  'GET_FEATURE_FLAGS_SUCCESS',
  'GET_FEATURE_FLAGS_FAILURE',

  'LOGOUT',

  'CLOSE_CCPA_BANNER',

  'CHECK_RATING_ADDRESS_ELIGIBILITY',
  'CHECK_RATING_ADDRESS_ELIGIBILITY_SUCCESS',
  'CHECK_RATING_ADDRESS_ELIGIBILITY_FAILURE',

  // XXX: Setting up for Auto store
  'UPDATE_ENROLLMENT_APPLICATION',
  'CLEAR_ENROLLMENT_APPLICATION',

  'CLEAR_AUTO_QUOTE',

  'CREATE_AUTO_QUOTE',
  'CREATE_AUTO_QUOTE_SUCCESS',
  'CREATE_AUTO_QUOTE_FAILURE',

  'GET_AUTO_QUOTE',
  'GET_AUTO_QUOTE_SUCCESS',
  'GET_AUTO_QUOTE_FAILURE',

  'UPDATE_AUTO_QUOTE',
  'UPDATE_AUTO_QUOTE_SUCCESS',
  'UPDATE_AUTO_QUOTE_FAILURE',

  'GET_AUTO_QUOTE_VARS',
  'GET_AUTO_QUOTE_VARS_SUCCESS',
  'GET_AUTO_QUOTE_VARS_FAILURE',

  'GET_AUTO_QUOTE_CHECKOUT',
  'GET_AUTO_QUOTE_CHECKOUT_SUCCESS',
  'GET_AUTO_QUOTE_CHECKOUT_FAILURE',

  'GET_VEHICLES_YEARS',
  'GET_VEHICLES_YEARS_SUCCESS',
  'GET_VEHICLES_YEARS_FAILURE',

  'GET_VEHICLES_MAKES',
  'GET_VEHICLES_MAKES_SUCCESS',
  'GET_VEHICLES_MAKES_FAILURE',

  'GET_VEHICLES_MODELS',
  'GET_VEHICLES_MODELS_SUCCESS',
  'GET_VEHICLES_MODELS_FAILURE',

  'UPDATE_CACHED_QUOTE_HEALTH_CHECK_STATE',

  'FINALIZE_AUTO_QUOTE',
  'FINALIZE_AUTO_QUOTE_SUCCESS',
  'FINALIZE_AUTO_QUOTE_FAILURE',

  'CREATE_OKTA_LOGIN_INFO',
  'CLEAR_OKTA_LOGIN_INFO',
  'CLEAR_OKTA_FOR_QA',

  'UPDATE_QUOTE_DATA',

  'UPDATE_POLICY_HEALTH_CHECK_ERROR_DETAILS',
  'CLEAR_POLICY_HEALTH_CHECK_ERROR_DETAILS',

  'UPDATE_HAS_LOGGED_IN_DURING_PF',

  'GET_CMS_CONTENT',
  'GET_CMS_CONTENT_SUCCESS',
  'GET_CMS_CONTENT_FAILURE',

  'EXCHANGE_QUOTE_AUTH_TOKEN',
  'EXCHANGE_QUOTE_AUTH_TOKEN_SUCCESS',
  'EXCHANGE_QUOTE_AUTH_TOKEN_FAILURE',
];

const ACTION_TYPES = zipObject(ACTIONS, ACTIONS);

export default ACTION_TYPES;
